// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import calSoftwareMng from './metaData/calSoftware'
export default {
  state: calSoftwareMng,
  actions
}
